class IsVideo {

    constructor() {

        return (p, adunit) => {
            if(typeof p === 'object' && Array.isArray(p)) {
                return p.filter( x=> x.contentType.startsWith("video/") );
            }
            else if(typeof p === 'string'){
                return p.startsWith("video/");
            }
            else {
                return false;
            }
        };
    }

}

angular.module('cpm')
.filter('isVideo', [ () => {
    'use strict';
    return new IsVideo();
}]);

